(() => {
  if (customElements.get('sl-curtain-customizer')) return;
  let configPromise;
  class CurtainCustomizer extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.s = JSON.parse(this.querySelector('[data-sl-strings]').textContent);
      try {
        configPromise ||= fetch(this.dataset.configUrl).then(r => { if (!r.ok) throw Error('configuration'); return r.json(); });
        const config = await configPromise;
        this.config = config;
        this.p = config.products.find(p => p.handle === this.dataset.handle);
        if (!this.p) throw Error('configuration');
        this.o = config.options;
        this.state = { construction:'rod_pocket', width_in:50, length_in:84, lining:'privacy', trim_style:'none', trim_location:'none', trim_color:'cream', sets:1 };
        const panel = this.querySelector('[data-sl-controls]');
        this.body = panel;
        panel.replaceChildren();
        this.build();
        this.update();
      } catch (error) {
        this.querySelector('[data-sl-status]').textContent = this.s.load_error;
      }
    }
    el(tag, text, className) {
      const el = document.createElement(tag);
      if (text !== undefined) el.textContent = text;
      if (className) el.className = className;
      return el;
    }
    group(label) {
      const fieldset = this.el('fieldset');
      fieldset.append(this.el('legend',label));
      this.body.append(fieldset);
      return fieldset;
    }
    choices(key, values, parent) {
      const wrap = this.el('div',undefined,'sl-options');
      for (const value of values) {
        const label = this.el('label',undefined,'sl-choice');
        const input = this.el('input');
        input.type = 'radio';
        input.name = `${this.dataset.instance}-${key}`;
        input.value = value;
        input.checked = this.state[key] === value;
        input.addEventListener('change',() => {
          this.state[key] = value;
          if (key === 'trim_style') {
            this.state.trim_location = value === 'none' ? 'none' : this.p.panels_per_set === 2 ? 'inside_pair' : 'left';
            this.trimFields.hidden = value === 'none';
            this.syncRadios('trim_location');
          }
          this.update();
        });
        label.append(input,this.el('span',typeof value === 'number' ? `${value}″` : this.s[value]));
        wrap.append(label);
      }
      parent.append(wrap);
    }
    syncRadios(key) {
      this.querySelectorAll(`input[name="${this.dataset.instance}-${key}"]`).forEach(input => input.checked = input.value === String(this.state[key]));
    }
    number(key,labelText,min,max,step,parent) {
      const label = this.el('label',undefined,'sl-label');
      label.append(this.el('span',labelText));
      const input = this.el('input');
      Object.assign(input,{type:'number',min:String(min),max:String(max),step:String(step),value:String(this.state[key]),required:true});
      input.dataset.field = key;
      input.addEventListener('input',()=>{this.state[key] = input.value.trim() === '' ? NaN : Number(input.value);this.update();});
      label.append(input);parent.append(label);
      return input;
    }
    build() {
      const fabrics = this.group(this.s.fabric);
      const select = this.el('select');
      select.setAttribute('aria-label',this.s.fabric);
      for (const product of this.config.products) {
        const option = this.el('option',product.title);
        option.value = product.handle;option.selected = product.handle === this.dataset.handle;select.append(option);
      }
      select.addEventListener('change',()=>{
        const url = new URL(this.dataset.productBase + select.value,location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        location.assign(url.href);
      });
      fabrics.append(select,this.el('p',this.s.fabric_navigation,'sl-note'));
      this.choices('construction',this.o.constructions,this.group(this.s.construction));
      const dimensions = this.group(this.s.dimensions);
      this.choices('width_in',this.o.widths_in,dimensions);
      dimensions.append(this.el('p',this.s.width_help,'sl-note'));
      this.number('length_in',`${this.s.length} (${this.p.min_length_in}–${this.p.max_length_in}″; ${this.s.step} ${this.p.length_step_in}″)`,this.p.min_length_in,this.p.max_length_in,this.p.length_step_in,dimensions);
      const help = this.el('details');help.append(this.el('summary',this.s.measure));
      help.append(this.el('p',this.s.measure_help));dimensions.append(help);
      this.choices('lining',this.o.linings,this.group(this.s.lining));
      const trim = this.group(this.s.trim);
      this.choices('trim_style',this.o.trim_styles,trim);
      this.trimFields = this.el('div');this.trimFields.hidden = true;
      this.trimFields.append(this.el('p',this.s.trim_location,'sl-label'));
      this.choices('trim_location',this.o.trim_locations.filter(v => v !== 'none' && (v !== 'inside_pair' || this.p.panels_per_set === 2)),this.trimFields);
      const colorLabel = this.el('label',this.s.trim_color,'sl-label');
      const colors = this.el('select');
      for (const color of this.o.trim_colors) {const option=this.el('option',this.s[color.id]);option.value=color.id;colors.append(option);}
      colors.addEventListener('change',()=>{this.state.trim_color = colors.value;this.update();});colorLabel.append(colors);
      this.trimFields.append(colorLabel,this.el('p',this.s.trim_help,'sl-note'));trim.append(this.trimFields);
      const quantity = this.group(this.p.panels_per_set === 2 ? this.s.set_quantity : this.s.panel_quantity);
      this.number('sets',this.p.panels_per_set === 2 ? this.s.sets : this.s.panels,1,20,1,quantity);
      this.diagram = this.el('figure',undefined,'sl-diagram');this.diagram.setAttribute('aria-label',this.s.diagram);
      this.body.append(this.diagram);
      const total = this.el('div',undefined,'sl-total');
      total.append(this.el('div',this.s.estimated_total));this.money = this.el('strong',undefined,'sl-money');
      this.summary = this.el('p',undefined,'sl-summary');
      this.error = this.el('p',undefined,'sl-error');this.error.setAttribute('role','alert');
      total.append(this.money,this.summary,this.error,this.el('p',this.s.preview_notice,'sl-note'));
      this.download = this.el('button',this.s.download,'button button--secondary');this.download.type='button';
      this.download.addEventListener('click',()=>this.save());total.append(this.download);
      const detail = this.el('details');detail.append(this.el('summary',this.s.pricing_details));
      this.breakdown = this.el('p',undefined,'sl-summary');detail.append(this.breakdown);total.append(detail);
      this.body.append(total);
      this.querySelector('[data-sl-status]').textContent = '';
    }
    update() {
      try {
        this.quote = globalThis.StarryLoomPricing.quote(this.p,this.state,this.o);
        this.error.textContent='';this.download.disabled=false;
        const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:'USD'}).format(value);
        this.money.textContent = `${money(this.quote.total_usd)} USD`;
        this.summary.textContent = `${this.quote.panel_count} ${this.s.panels} · ${this.state.width_in}″ × ${this.state.length_in}″ ${this.s.each_panel} · ${money(this.quote.panel_usd)} ${this.s.per_panel}`;
        this.breakdown.textContent = this.s.pricing_explanation;
        this.draw();
      } catch (error) {
        this.quote=null;this.money.textContent='—';this.summary.textContent='';this.download.disabled=true;
        this.error.textContent=error.message === 'configuration' ? this.s.load_error : this.s.invalid;
      }
    }
    draw() {
      this.diagram.replaceChildren();
      const panels = this.el('div',undefined,'sl-panels');panels.setAttribute('aria-hidden','true');
      const color = this.o.trim_colors.find(c=>c.id === this.state.trim_color);
      panels.style.setProperty('--sl-trim-color',color.hex);
      for(let i=0;i<this.p.panels_per_set;i++) {
        const panel = this.el('div',undefined,`sl-panel${this.quote.pleated ? ' sl-pleated' : ''}${this.state.construction === 'grommet' ? ' sl-grommet' : ''}`);
        let edges = [];
        if(this.state.trim_location === 'inside_pair') edges = [i === 0 ? 'right' : 'left'];
        if(['left','right'].includes(this.state.trim_location)) edges = [this.state.trim_location];
        if(this.state.trim_location === 'sides_bottom') edges = ['left','right','bottom'];
        edges.forEach(edge=>panel.append(this.el('span',undefined,`sl-edge sl-${edge}`)));panels.append(panel);
      }
      this.diagram.append(panels,this.el('figcaption',this.s.diagram,'sl-note'));
    }
    save() {
      if(!this.quote) return;
      const quote = { version:this.config.version,created_at:new Date().toISOString(),product_id:this.p.product_id,handle:this.p.handle,product_title:this.p.title,panels_per_set:this.p.panels_per_set,selection:this.state,estimate:this.quote,production_note:this.state.trim_location === 'inside_pair' ? 'Each set: panel 1 right trim; panel 2 left trim.' : '',notice:this.s.preview_notice };
      const blob = new Blob([JSON.stringify(quote,null,2)],{type:'application/json'});
      const url=URL.createObjectURL(blob);const link=this.el('a');link.href=url;link.download=`starry-loom-${this.p.handle}.json`;link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
    }
  }
  customElements.define('sl-curtain-customizer',CurtainCustomizer);
})();
